<div class="form-group">
    @if (field.ShowName) {
        @if (this.field.Valid === false || this.field.Validation) {
            <label
                class="field-title text-danger"
                for="field-{{ field.ID }}"
                [title]="field.Required ? ('formEntryField.requiredFieldTitle' | t) : ''"
            >
                <i class="fas fa-exclamation-circle"></i>
                {{ field.Name }}
                @if (field.Required) {
                    <span> *</span>
                }
            </label>
        } @else if (this.field.Valid == null) {
            <label
                class="field-title"
                for="field-{{ field.ID }}"
                [title]="field.Required ? ('formEntryField.requiredFieldTitle' | t) : ''"
            >
                {{ field.Name }}
                @if (field.Required) {
                    <span> *</span>
                }
            </label>
        } @else {
            <label
                class="field-title text-success"
                for="field-{{ field.ID }}"
                [title]="field.Required ? ('formEntryField.requiredFieldTitle' | t) : ''"
            >
                <i class="fas fa-check-circle"></i>
                {{ field.Name }}
                @if (field.Required) {
                    <span> *</span>
                }
            </label>
        }
    }
    @if (field.Validation) {
        <small class="form-text text-danger">{{ field.Validation }}</small>
    }
    <small class="form-text text-muted" [hidden]="!field.AdditionalLabel || readonly">{{
        field.AdditionalLabel
    }}</small>
</div>

<ng-template #customComponent></ng-template>

@if (isReview) {
    <div class="form-group field-comment">
        <cerrix-textarea
            [(ngModel)]="comment"
            (valueChange)="commentValueChange()"
            placeholder="{{ 'formEntryField.reviewCommentPlaceholder' | t }}"
        ></cerrix-textarea>
    </div>
} @else if (comment) {
    <div class="form-group field-comment">
        <small class="text-muted">{{ 'formEntryField.commentFromReviewer' | t }}</small><br />
        <pre class="readonly-comment">{{ comment }}</pre>
    </div>
}
